var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlackHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6095 13.7241L12.2248 10.3394C12.9241 9.28543 13.3335 8.02342 13.3335 6.66674C13.3335 2.9907 10.3428 0 6.66674 0C2.9907 0 0 2.9907 0 6.66674C0 10.3428 2.9907 13.3335 6.66674 13.3335C8.02342 13.3335 9.28543 12.9241 10.3394 12.2248L13.7241 15.6095C14.2442 16.1302 15.0895 16.1302 15.6095 15.6095C16.1302 15.0888 16.1302 14.2448 15.6095 13.7241ZM2.00002 6.66674C2.00002 4.09338 4.09338 2.00002 6.66674 2.00002C9.2401 2.00002 11.3335 4.09338 11.3335 6.66674C11.3335 9.2401 9.2401 11.3335 6.66674 11.3335C4.09338 11.3335 2.00002 9.2401 2.00002 6.66674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlackHead);
export default __webpack_public_path__ + "static/media/searchBlackHead.0d21162da73986e6f7887a13e8fc95f8.svg";
export { ForwardRef as ReactComponent };